// Write your code here

import './index.css'

const PlanetItem = props => {
  const {planetsDetails} = props
  const {name, imageUrl, description} = planetsDetails

  return (
    <div className="planet-container">
      <img className="planets-img" src={imageUrl} alt={`planet ${name}`} />
      <h1 className="name-heading">{name}</h1>
      <p className="description-para">{description}</p>
    </div>
  )
}

export default PlanetItem
